<template>
  <div>
    <!-- <pre>
      {{ emails }}
    </pre> -->
    <v-data-table
      :headers="headers"
      :items="emails"
      :loading="loading"
      :search="search"
    >
      <template v-slot:[`item.open`]="{ item }">
        <v-btn small @click="openEmail(item)">
          Open Message
        </v-btn>
      </template>
      <template v-slot:[`item.reg_date`]="{ item }">
        {{ moment(item.reg_date) }}
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      persistent
      :overlay="false"
      width="580px"
      transition="dialog-transition"
    >
      <div class="bg-gray-100">
        <div class="flex justify-end p-1">
          <v-btn text small @click="dialog = false">
            <v-icon small>
              mdi-close
            </v-icon>
          </v-btn>
        </div>
        <EmailContent :selectedEmail="selectedEmail" />
      </div>
    </v-dialog>
  </div>
</template>

<script>
import EventBus from "@/EventBus";
import EmailContent from "./emailContent.vue";
import axios from "axios";
import moment from "moment";
export default {
  components: { EmailContent },
  data() {
    return {
      selectedEmail: null,
      dialog: false,
      theMessage: "",
      search: "",
      emails: [],
      loading: false,
      headers: [
        {
          text: "Email",
          value: "email_address",
        },
        {
          text: "Subject",
          value: "subject",
        },

        {
          text: "Date",
          value: "reg_date",
        },
        {
          text: "Open",
          value: "open",
        },
      ],
    };
  },
  mounted() {
    this.get_emails();
    EventBus.$on("GetEmailsAnonymous", () => {
      this.get_emails();
    });
  },
  methods: {
    openEmail(item) {
      this.selectedEmail = item;
      this.dialog = true;
    },
    moment(date) {
      return moment(date).format("ll");
    },
    get_emails() {
      this.loading = true;
      axios
        .get("/email/anonymous")
        .then((res) => {
          this.emails = res.data.emails;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
